import { ROUTE_TITLE, WATER_SERVICE_PROVIDER, WATER_SUPPLY_LENGTH_OF_MAINS_KPI_CODE } from "../misc";
import React, { useCallback, useState } from "react";
import { EInfographicWithNumbers } from "../../Components/SVG";
import { Section } from "../Container";
import { StdButton } from "../StdButton";
import styles from "./OverviewPage.module.scss";
import { Link } from "react-router-dom";
import { buildUri, ROUTE } from "../misc";
import { queryKpisOpenData } from "../misc/kpiOpenApi";
import _ from "lodash";
import { useAsync } from "../hooks";
import { event as exploreProviderEvent } from "../GA/Home/ExploreProvidersLinkButton";

export const OverviewPage: React.FC<{}> = () => {
    document.title = ROUTE_TITLE.HOME;
    const [year, setYear] = useState<number>(null);

    const loadData: (signal?: AbortSignal) => Promise<number> = useCallback(async signal => {
        const records = await queryKpisOpenData(
            { kpis: [[WATER_SUPPLY_LENGTH_OF_MAINS_KPI_CODE, WATER_SERVICE_PROVIDER]] },
            [],
            {
                signal
            }
        );
        const latestYear = _.max(records?.map(d => d.year));
        return latestYear;
    }, []);

    useAsync(loadData, setYear);

    return (
        <div>
            <Section
                faIcon="fa-solid fa-camera"
                className={styles.overviewSection}
                title={`Statewide snapshot ${year ?? ""}`}
                theme="statewide-snapshot"
            >
                <div className="double-margin-bottom"></div>
                <EInfographicWithNumbers className="triple-margin-bottom" year={year} />
                <div className={styles.center}>
                    <Link
                        to={buildUri(ROUTE.SEARCH_PAGE, {}, {})}
                        className={"linkButton"}
                        onClick={() => {
                            exploreProviderEvent();
                        }}
                    >
                        <StdButton className={styles.exploreProviders}>
                            <span className={"fa-solid fa-magnifying-glass"}></span>
                            Explore providers
                        </StdButton>
                    </Link>
                </div>
            </Section>
        </div>
    );
};
